/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { Component, type ErrorInfo, type ReactNode } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { colors } from '../../shared/theme/colors'
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography';
import { styles as reportStyles } from './ReportsScreen.styles';
import { ReportsDenseListCard } from './components/ReportsDenseListCard';
import { ticketColors } from '../../shared/theme/ticketColors';

type Props = { children: ReactNode };

type State = { hasError: boolean; message: string | null };

export class ReportsErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { hasError: true, message: error?.message ?? 'Error desconocido' };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.warn('[Reports]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <View style={styles.wrap} accessibilityLabel="Error en informes">
          <ReportsDenseListCard wrapStyle={{ borderColor: colors.danger }} bodyStyle={{ paddingVertical: spacing.lg, paddingHorizontal: spacing.lg }}>
            <Text style={reportStyles.reportsDenseBlockTitle}>No se pudieron cargar Informes</Text>
            <Text style={styles.body}>{this.state.message}</Text>
            <TouchableOpacity
              style={reportStyles.primaryButton}
              onPress={() => this.setState({ hasError: false, message: null })}
              accessibilityRole="button"
              accessibilityLabel="Reintentar"
            >
              <Text style={reportStyles.primaryButtonText}>Reintentar</Text>
            </TouchableOpacity>
          </ReportsDenseListCard>
        </View>
      );
    }
    return this.props.children;
  }
}

const styles = StyleSheet.create({
  wrap: {
    flex: 1,
    padding: spacing.lg,
    backgroundColor: ticketColors.bg,
    justifyContent: 'center',
    gap: spacing.md,
  },
  body: {
    ...typography.body,
    color: ticketColors.ink2,
  },
});
